import React from 'react';
import styled from 'styled-components/macro';
import { ButtonRow, PrimaryButton, SecondaryButton } from '../../../shared/Button';
import { Expandable } from '../../../shared/Expandable';
import { colourNeutral06, colourRed05 } from '../../../styling/colours';
import { spacing04, spacing05 } from '../../../styling/spacing';

type Props = {
  isConfirmingDelete: boolean;
  setIsConfirmingDelete: (value: boolean) => void;
  deleteItem: () => void;
  deleteButtonTestId?: string;
};

export const DeleteConfirmation = ({
  isConfirmingDelete,
  setIsConfirmingDelete,
  deleteItem,
  deleteButtonTestId,
}: Props) => {
  return (
    <Expandable isExpanded={isConfirmingDelete}>
      <DeleteConfirmationContainer>
        <ConfirmationPromptText>Are you sure you wish to delete this item? </ConfirmationPromptText>
        <ButtonRow $align="left">
          <DeleteButton onClick={deleteItem} data-testid={deleteButtonTestId}>
            Delete
          </DeleteButton>
          <CancelButton onClick={() => setIsConfirmingDelete(false)}>Cancel</CancelButton>
        </ButtonRow>
      </DeleteConfirmationContainer>
    </Expandable>
  );
};

const ConfirmationPromptText = styled.p`
  margin-bottom: ${spacing04};
`;

const DeleteConfirmationContainer = styled.div`
  margin-bottom: ${spacing05};
`;

const DeleteButton = styled(PrimaryButton)`
  background: ${colourRed05};
`;

const CancelButton = styled(SecondaryButton)`
  background: transparent;
  border: solid 1px ${colourNeutral06};
`;
